














































import Vue from "vue";
import VaNotification from "@/components/molecules/VaNotification.vue";
import AuthTemplate from "@/components/templates/Auth.vue";
import VaCard from "@/components/molecules/VaCard.vue";
import VaButton from "@/components/atoms/VaButton.vue";
import errorMixin from "@/components/mixins/errorMixin";
import validationMixin from "@/components/mixins/validationMixin";
import VaTextField from "@/components/atoms/VaTextField.vue";
import i18n from "@/i18n";
import userService from "@/services/userService";

export default Vue.extend({
  name: "ConfirmInvitation",
  components: {
    VaButton,
    VaCard,
    AuthTemplate,
    VaTextField,
    VaNotification,
  },
  mixins: [errorMixin, validationMixin],
  data() {
    return {
      password: "",
      confirmPassword: "",
      loading: false,
    };
  },
  computed: {
    success(): boolean {
      return Boolean(this.mail && this.token);
    },
    token(): string | undefined {
      return this.$route.query.token as string | undefined;
    },
    mail(): string | undefined {
      return this.$route.query.mail as string | undefined;
    },
  },
  methods: {
    matching(value: string) {
      return value === this.password || i18n.t("validate.confirmed");
    },
    async onConfirm(): Promise<void> {
      if (!this.success) {
        return;
      }

      const form = this.$refs.confirmForm as Vue & {
        validate: () => boolean;
      };

      if (!form.validate()) {
        return;
      }

      this.loading = true;
      try {
        await userService.confirmAdminInvitation(
          this.mail as string,
          encodeURIComponent(this.token as string),
          this.password
        );
        this.$store.commit(
          "notifications/displayNotification",
          {
            message: i18n.t("usersList.invitationConfirmed"),
            type: "success",
          },
          { root: true }
        );
        this.$router.push({ path: "/auth/signin" });
      } catch (error) {
        this.$store.commit(
          "notifications/displayNotification",
          { message: error, type: "error" },
          { root: true }
        );
      } finally {
        this.loading = false;
      }
    },
  },
});
